var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.618 54.727 55.505 0l6.254 6.273L6.872 61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.073 1.046 56.424 53.14-6.073 6.449L0 7.495z"
  })));
};
export default SvgClose;